import { useMaterialPreparationWorkspace } from "./preparation/useMaterialPreparationWorkspace";
import { MaterialPreparationView } from "./preparation/MaterialPreparationView";
export function MaterialPreparationPanel(props: Parameters<typeof useMaterialPreparationWorkspace>[0]) {
 const workspace = useMaterialPreparationWorkspace(props);
 return <MaterialPreparationView user={props.user} notify={props.notify} workspace={workspace} />;
}
